import { render, staticRenderFns } from "./QualifiedInvestor.vue?vue&type=template&id=484eecdc&scoped=true&"
import script from "./QualifiedInvestor.vue?vue&type=script&lang=ts&"
export * from "./QualifiedInvestor.vue?vue&type=script&lang=ts&"
import style0 from "./QualifiedInvestor.vue?vue&type=style&index=0&id=484eecdc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484eecdc",
  null
  
)

export default component.exports